export type { LemonSkeletonProps } from './LemonSkeleton'
export { LemonSkeleton } from './LemonSkeleton'
